import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const withSessionStorage = (Component, paramName) => {
  return (props) => {
    const paramValue = props.match.params[paramName];
    const sessionValue = sessionStorage.getItem(paramName);

    if (paramValue === 'undefined' && sessionValue) {
      const newPath = props.location.pathname.replace(`${paramValue}`, sessionValue);
      return <Redirect to={newPath} />;
    }

    return <Component {...props} />;
  };
};

export default withSessionStorage;